<template>
    <div>
        <div v-for="(item, idx) in value" :key="idx" class="mb-3">
            <template v-if="item && item.doc_pre_atend">
                <az-sub-title :title="item.doc_pre_atend.st_titulo" :big="true">
                    {{ item.doc_pre_atend.created_at ? ( $util.getFormatDate(item.doc_pre_atend.created_at.substr(0, 10)) + item.doc_pre_atend.created_at.substr(10, 6) ) : '' }}
                </az-sub-title>

                <formulario 
                    :compact="item.doc_pre_atend.fl_compact"
                    v-model="item.doc_pre_atend.js_conteudo" 
                    v-if="item" 
                    :saved="saved" 
                    :mode="view ? 'view' : 'fixed'"
                    :validate="validate"
                    :config="true"
                    :id_atendimento="marcacao ? marcacao.id_atendimento : null"
                    :id_procedimento="marcacao ? marcacao.id_procedimento : null"
                    :is_preatendimento="true" />
            </template>

            <template v-else-if="item">
                <az-sub-title :title="item.st_titulo" :big="true">
                    {{ item.created_at ? ( $util.getFormatDate(item.created_at.substr(0, 10)) + item.created_at.substr(10, 6) ) : '' }}
                </az-sub-title>

                <formulario 
                    :compact="item.fl_compact"
                    v-model="item.js_conteudo" 
                    :id_atendimento="marcacao ? marcacao.id_atendimento : null"
                    :id_procedimento="marcacao ? marcacao.id_procedimento : null"
                    v-if="item" 
                    :saved="saved" 
                    :mode="view ? 'view' : 'fixed'"
                    :validate="validate"
                    :config="true"
                    :textos="[]"
                    :is_preatendimento="true" />
            </template>
        </div>
    </div>
</template>

<script>
import Formulario from '../consultorio/Formulario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';

export default {

    data () { 
        return { 
            saved: true, 
            pre_atendimentos: null,
        }
    }, 

    props: ['value', 'validate', 'view', 'marcacao'],

    components: { 
        AzSubTitle,
        Formulario,
    },

    watch: {
        value: {
            handler() {
                this.$emit('input', this.value);
            },
            deep: true,
            immediate: true,
        },
    }

}
</script>